export const config = {
  title: 'Configs time work',
  header: 'Configs time work',
  versionApp: 'Config version app',
  save: 'Save',
}
